<template>
  <div class="tc-modal-order tc-modal-body">
    <div class="tc-modal-label">
      Оформить заказ
    </div>
    <div class="tc-modal-input-group">
      <div class="tc-modal-text">
        Имя:
      </div>
      <input class="tc-default-input"
             :value="name"
             @input="name = $event.target.value">
    </div>
    <div class="tc-field-error-anchor"
         v-show="isErrorName">
      <div class="tc-field-error">
        Обязательное поле!
      </div>
    </div>
    <div class="tc-modal-input-group">
      <div class="tc-modal-text">
        Email:
      </div>
      <input class="tc-default-input"
             :value="email"
             @input="email = $event.target.value"
             placeholder="mail@example.com">
    </div>
    <div class="tc-field-error-anchor"
         v-show="isErrorEmail">
      <div class="tc-field-error">
        Неверный формат E-mail!
      </div>
    </div>
    <div class="tc-modal-input-group">
      <div class="tc-modal-text">
        Телефон:
      </div>
      <input class="tc-default-input"
             :value="phone"
             v-mask="'+###################'"
             @input="phone = $event.target.value">
    </div>
    <div class="tc-field-error-anchor"
         v-show="isErrorPhone">
      <div class="tc-field-error">
        Неверный формат номера!
      </div>
    </div>
    <div class="tc-modal-input-group">
      <div class="tc-modal-text">
        Комментарий к заказу :
      </div>
      <textarea class="tc-modal-textarea"
                :value="comment"
                @input="comment = $event.target.value">
            </textarea>
    </div>
    <div class="tc-policy-confirm">
      <input type="checkbox"
             class="tc-policy-cb"
             :checked="isConfirmedPP"
             @change="isConfirmedPP = $event.target.checked">
      <div class="tc-policy-confirm-text">
        Согласен с условиями
        <a class="bc-link" href="https://www.safe.ru/legal/policy/" target="_blank">
          политики конфиденциальности.
        </a>
      </div>
    </div>
    <div class="tc-field-error-anchor"
         v-show="isErrorPP">
      <div class="tc-field-error">
        Обязательное поле!
      </div>
    </div>
    <div class="tc-modal-two-buttons">
      <OutlineButton :text="'Отмена'"
                     @click="cancel()"/>
      <OrangeButtonOfLawlessness :text="'Отправить'"
                                 @click="submit()"/>
    </div>
  </div>
</template>

<script>

import OutlineButton from '@/UI/CommonComponents/OutlineButton.vue';
import OrangeButtonOfLawlessness from '@/UI/CommonComponents/OrangeButtonOfLawlessness.vue';
import { useStoreUI } from '@/Store/storeUI';
import { order } from '@/utils/postmessages';
import { isValidEmail } from '@/libs/emailValidator';
import { isValidPhoneNumber } from '@/libs/phoneValidator';
import { useStoreMeta } from '@/Store/storeMeta';

export default {
  name: 'ModalOrder',
  components: {
    OrangeButtonOfLawlessness,
    OutlineButton,
  },
  setup() {
    const storeUI = useStoreUI();
    const storeMeta=useStoreMeta();
    return {
      storeUI,
      storeMeta,
    };
  },
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      comment: '',
      isConfirmedPP: false,
      isErrorName: false,
      isErrorEmail: false,
      isErrorPhone: false,
      isErrorPP: false,
    };
  },
  methods: {
    resetErrors() {
      this.isErrorName = false;
      this.isErrorEmail = false;
      this.isErrorPhone = false;
      this.isErrorPP = false;
    },
    cancel() {
      this.storeUI.setIsShowModal(false);
    },
    submit() {
      this.resetErrors();
      if (!this.isConfirmedPP) {
        this.isErrorPP = true;
        return;
      } else if (this.name.length < 2) {
        this.isErrorName = true;
        return;
      } else if (!isValidEmail(this.email)) {
        this.isErrorEmail = true;
        return;
      } else if (!isValidPhoneNumber(this.phone)) {
        this.isErrorPhone = true;
        return;
      }
      const customerData = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        comment: this.comment,
      };
      order(customerData);
      this.storeUI.setIsShowModal(false);
    },
  },
  mounted() {
    if(this.storeMeta.role){
      this.name = this.storeMeta.name;
      this.phone = '';
      this.email = this.storeMeta.email;
      this.comment = '';
    }

  },
};
</script>

<style scoped lang="scss">
@import "CSS/modal";

.tc-modal-order {
  width: 310px;
}
</style>
